import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { templatesAPI } from '../../services/api';

export const fetchTemplates = createAsyncThunk('templates/fetchAll', async (params, { rejectWithValue }) => {
  try { const res = await templatesAPI.list(params); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed'); }
});

const templatesSlice = createSlice({
  name: 'templates',
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTemplates.pending, (state) => { state.loading = true; })
      .addCase(fetchTemplates.fulfilled, (state, action) => { state.loading = false; state.items = action.payload.templates; })
      .addCase(fetchTemplates.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export default templatesSlice.reducer;
